<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{heading}}</label>
  </div>
</header>

<!-- <app-notification-message class="mt-3" [errorMessage]="errorMessage" [successMessage]="successMessage">
</app-notification-message> -->
<div
      class="px-3"
      *ngIf="successMessage != null"
      class="alert alert-success alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="closeMessage()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ successMessage }}</strong>
    </div>
    <div
      class="px-3"
      *ngIf="errorMessage != null"
      class="alert alert-danger alert-dismissible fade show p-2 ms-4 me-4"
      role="alert"
    >
      <button
        type="button"
        class="btn-close"
        (click)="closeMessage()"
        data-bs-dismiss="alert"
        aria-label="close"
      ></button>
      <strong>{{ errorMessage }}</strong>
    </div>
<div class="grid p-2">
  <div class="grid-item">
    <div class="toTheCenter">
      <mat-icon *ngIf="img1" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!img1" [src]="image1" alt="partImage" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif"  size="300" class="imageClass mt-2 mb-2" />
      <!-- <mat-icon *ngIf="!image1" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!!image1" [src]="image1" alt="partImage" accept=".png, .jpg" size="300" /> -->
    </div>
    <div class="d-flex align-items-center justify-content-center gap-3">
      <label *ngIf="!upload1" class="choose-btn-table">
        CHOOSE FILE
        <input type="file" id="file-upload2" style="display: none" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif" (click)="onClick($event)"
          (change)="handleUpload1($event,'packagingImage')" />
         </label>
      <img *ngIf="upload1" src="assets/images/noun_edit_1570019.svg" alt="D" (click)="handleDelete1(timageId1)" class="del-btn-table" />
      <img *ngIf="!upload1" src="assets/images/upload-solid.svg" alt="D" (click)="saveClick(file1,1)" class="del-btn-table" />
      <!-- <img *ngIf="!upload1" src="assets/images/upload-solid.svg" alt="D" (click)="newsaveClick(file1,1)" class="del-btn-table" /> -->

    </div>
  </div>
  <div class="grid-item">
    <div class="toTheCenter">
      <mat-icon *ngIf="img2" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!img2" [src]="image2" alt="partImage" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif"  size="300" class="imageClass mt-2 mb-2" />
      <!-- <mat-icon *ngIf="!image2" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!!image2" [src]="image2" alt="partImage" accept=".png, .jpg" size="300" /> -->
    </div>
    <div class="d-flex align-items-center justify-content-center gap-3">
      <label *ngIf="!upload2" class="choose-btn-table">
        CHOOSE FILE
        <input type="file" id="file-upload2" style="display: none" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif" (click)="onClick($event)"
          (change)="handleUpload2($event,'packagingImage')"  /> </label>
      <img *ngIf="upload2" src="assets/images/noun_edit_1570019.svg" alt="D" (click)="handleDelete2(timageId2)" class="del-btn-table" />
      <img *ngIf="!upload2" src="assets/images/upload-solid.svg" alt="D" (click)="saveClick(file2,2)" class="del-btn-table" />
      <!-- <img *ngIf="!upload2" src="assets/images/upload-solid.svg" alt="D" (click)="newsaveClick(file2,2)" class="del-btn-table" /> -->

    </div>
  </div>
  <div class="grid-item">
    <div class="toTheCenter">
      <mat-icon *ngIf="img3" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!img3" [src]="image3" alt="partImage" accept=".png, .jpg" size="300" class="imageClass mt-2 mb-2" />
      <!-- <mat-icon *ngIf="!image3" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!!image3" [src]="image3" alt="partImage" accept=".png, .jpg" size="300" /> -->
    </div>
    <div class="d-flex align-items-center justify-content-center gap-3">
      <label *ngIf="!upload3" class="choose-btn-table">
        CHOOSE FILE
        <input type="file" id="file-upload2" style="display: none" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif"  (click)="onClick($event)"
          (change)="handleUpload3($event,'packagingImage')" /> </label>
      <img *ngIf="upload3" src="assets/images/noun_edit_1570019.svg" alt="D" (click)="handleDelete3(timageId3)" class="del-btn-table" />
      <img *ngIf="!upload3" src="assets/images/upload-solid.svg" alt="D" (click)="saveClick(file3,3)" class="del-btn-table" />
      <!-- <img *ngIf="!upload3" src="assets/images/upload-solid.svg" alt="D" (click)="newsaveClick(file3,3)" class="del-btn-table" /> -->

    </div>
  </div>
  <div class="grid-item">
    <div class="toTheCenter">
      <mat-icon *ngIf="img4" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!img4" [src]="image4" alt="partImage" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif"  size="300" class="imageClass mt-2 mb-2" />
      <!-- <mat-icon *ngIf="!image4" class="text-secondary">panorama</mat-icon>
      <img *ngIf="!!image4" [src]="image4" alt="partImage" accept=".png, .jpg" size="300" /> -->
    </div>
    <div class="d-flex align-items-center justify-content-center gap-3">
      <label *ngIf="!upload4" class="choose-btn-table">
        CHOOSE FILE
        <input type="file" id="file-upload2" style="display: none" accept=".png, .jpg,.jpeg,.jpe,.jif,.jfif,.jfi,.jp2,.j2k,.jpf,.jpm,.jpg2,.j2c,.jpc,.jpx,.mj2,.gif,.tiff,.tif" (click)="onClick($event)"
          (change)="handleUpload4($event,'packagingImage')"  /> </label>
        <img *ngIf="upload4" src="assets/images/noun_edit_1570019.svg" alt="D" (click)="handleDelete4(timageId4)" class="del-btn-table" />
      <img *ngIf="!upload4" src="assets/images/upload-solid.svg" alt="D" (click)="saveClick(file4,4)" class="del-btn-table" />
      <!-- <img *ngIf="!upload4" src="assets/images/upload-solid.svg" alt="D" (click)="newsaveClick(file4,4)" class="del-btn-table" /> -->

    </div>
  </div>
</div>

<!-- <div class="footer">
  <button (click)="onNoClick()" class="cancel"
    style="display: inline; background: transparent; border: none !important">
    CANCEL
  </button>
  <button mat-raised-button class="submit" style="display: inline" (click)="saveClick()">
    SAVE
  </button>
</div> -->

<div class="footer d-flex justify-content-end align-items-center fixed-bottom py-1 ps-4">
  <button class="cancel me-3 roboto-bold" (click)="onNoClick()"> CANCEL </button>
  <!-- <button class="submit black-button me-3 roboto-medium" (click)="saveClick()">SAVE</button> -->
</div>
</div>